<template>
  <div>
    <el-dialog :title="data.tranferType == 1 || data.tranferType == 4 ? '申请报价' : '申请摘牌'" v-loading.fullscreen.lock="loading" :visible="show" :close-on-click-modal="false" width="60%" @close="close">
      <div class="dia_wrap" v-if="data.tranferType != 4">
        <el-form class="form" ref="formRef" :model="formData" :rules="rules" label-position="left" label-width="140px" size="mini">
          <div>
            <div class="m50">
              <el-form-item label="相关资料">
                <Upload v-model="fileUrlInfo" @fileNameEvt="fileNameEvt" buttonText="上传资料" :size="true"></Upload>
                <div v-for="(item, index) in formData.delistingInfos" :key="index">
                  <div class="lookAddr">
                    <span class="name">{{ item.name }}</span>
                    <el-link class="mr20 blueC" :underline="false" v-if="item.url" :href="item.url" target="_blank">详情</el-link>
                    <i @click.prevent.stop="formData.delistingInfos.splice(index, 1)" class="el-icon-delete"></i>
                  </div>
                </div>
              </el-form-item>
              <el-row class="mt20">
                <el-col v-for="item of fileList" :key="item.fileType">
                  <div v-if="item.maxNumber == 1">
                    <el-form-item :label="item.fileName" label-width="330px" style="margin-bottom: 10px"  :class="{'actives': item.isRequire }">
                      <OneUpload :fileFuther="item" />
                    </el-form-item>
                  </div>
                  <div v-else>
                    <el-form-item :label="`${item.fileName}(可上传多份)`" label-width="330px" style="margin-bottom: 10px"  :class="{'actives': item.isRequire }">
                      <ListUpload :fileFuther="item"  />
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="h_bg p50" style="margin-top: 0">
              <h3>摘牌人信息</h3>
              <span>带“*”号为必填项</span>
            </div>
            <div class="m50">
              <el-form-item label="摘牌人身份">
                <el-radio-group disabled v-model="formData.userType" @change="changeRadio">
                  <el-radio label="2">企业</el-radio>
                  <el-radio label="1">个人</el-radio>
                  <el-radio label="3">行政事业单位</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="姓名" prop="name" v-if="formData.userType == 1">
                <el-input disabled class="input_width" v-model="formData.name"  placeholder="请输入姓名" :maxlength="10"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="identityCode" v-if="formData.userType == 1">
                <el-input disabled class="input_width" v-model.trim="formData.identityCode"  placeholder="请输入身份证号" :maxlength="18"></el-input>
              </el-form-item>
              <!-- <el-form-item label="法定代表人" prop="legalPerson" v-if="formData.userType == 2"> -->
              <el-form-item :label="formData.userType==3 ?'代表人姓名':'法人姓名'" prop="legalPerson" v-if="formData.userType != 1">
                <el-input disabled class="input_width" v-model="formData.legalPerson"  placeholder="请输入法定代表人" :maxlength="10"></el-input>
              </el-form-item>
              <!-- <el-form-item label="联系电话" prop="contactPhone" v-if="formData.userType == 1 || formData.userType == 2"> -->
              <el-form-item label="联系电话" prop="contactPhone">
                <el-input class="input_width" v-model.trim="formData.contactPhone"  placeholder="请输入联系电话" :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="联系地址" prop="contactAddress" v-if="formData.userType == 1">
                <el-input class="input_width" v-model="formData.contactAddress"  placeholder="请输入联系地址" :maxlength="100"></el-input>
              </el-form-item>
              <!-- <el-form-item label="企业名称" prop="enterpriseName" v-if="formData.userType == 2"> -->
              <el-form-item :label="formData.userType==3 ?'单位名称':'企业名称'" prop="enterpriseName" v-if="formData.userType != 1">
                <el-input disabled class="input_width" v-model="formData.enterpriseName"  placeholder="请输入企业名称" :maxlength="50"></el-input>
              </el-form-item>
              <!-- <el-form-item label="注册住址" prop="registAddress" v-if="formData.userType == 2"> -->
              <el-form-item :label="formData.userType==3 ?'住所':'注册地址'" prop="registAddress" v-if="formData.userType != 1">
                <el-input disabled class="input_width" v-model="formData.registAddress"  placeholder="请输入注册住址" :maxlength="100"></el-input>
              </el-form-item>
              <!-- <el-form-item label="统一信用代码" prop="creditCode" v-if="formData.userType == 2"> -->
              <el-form-item label="统一信用代码" prop="creditCode" v-if="formData.userType != 1">
                <el-input disabled class="input_width" v-model="formData.creditCode"  placeholder="请输入统一信用代码" :maxlength="50" @change="getAuthInfo"></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if="data.tranferType == 1">
            <div class="h_bg p50">
              <h3>报价信息</h3>
            </div>
            <div class="m50">
              <div class="mar15">
                最高报价(元)<span style="margin-right: 150px;margin-left: 20px;">{{
                  data.maxReportAmount || '无'
                }}</span>
                竞价阶梯(元/次)<span>{{ data.auctionInterval || '无' }}</span>
              </div>
              <span style="margin-right: 20px">报价金额(元)</span>
              <el-input class="input_width" v-model="formData.amount" placeholder="请输入报价金额" size="mini"></el-input>
              <span class="ml20" style=" background: #e8f1ff; border-radius: 18px; padding: 10px 20px; color: #047eff; ">{{ data.amount }}元起拍</span>
            </div>
          </div>
          <div v-else>
            <div class="h_bg p50">
              <h3>选择摘牌方式</h3>
            </div>
            <div class="m50">
              <el-radio-group v-model="formData.payType">
                <el-radio :label="1">全额付款</el-radio>
                <el-radio :label="2" :disabled="!data.advancePaymentAmount">预付款</el-radio>
                <div style="display: inline-block; margin-left: 20px">
                  <el-radio :label="3" v-if="applyStatus == 1">交付后再付</el-radio>
                  <el-radio :label="4" v-if="applyStatus == 1">其他</el-radio>
<!--                  <el-button v-if="applyStatus != -1 && applyStatus != 1" type="primary" :disabled="applyStatus === 0" size="mini" @click="upDia = true">申请其他方式</el-button>-->
                  <el-button v-if="isShowBtn" type="primary" :disabled="applyStatus === 0" size="mini" @click="upDia = true">申请其他方式</el-button>
                </div>
                <el-input style="width: 170px; margin-left: 10px" v-if="formData.payType == 4" v-model="formData.payInfo" placeholder="请输入" size="mini"></el-input>
              </el-radio-group>
            </div>
          </div>
          <div v-if="data.payWay==2&&data.tranferType != 1&&formData.payType==1">
            <div class="h_bg p50">
              <h3>分期信息</h3>
            </div>
            <div class="m50">
              <el-form-item label="分期金额（元）">
                <span>{{data.amount}}</span>
              </el-form-item>
              <el-form-item label="分期期数" prop="stageNum">
                <el-select v-model="formData.stageNum" placeholder="请选择" @change="stageNumFn">
                  <el-option v-for="(item, ind) in stageNumOptionsFilter()" :key="ind" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="首期金额（元）">
                <span>{{formData.firstStageAmount}}</span>
              </el-form-item>
              <el-form-item label="剩余每期金额（元）">
                <span>{{formData.eachStageAmount}}</span>
              </el-form-item>
            </div>
          </div>
          <div class="transfer_wrap" v-if="isPromisePayed != 1">
            <div class="pop" v-show="formData.payType == 3 || formData.payType == 4"></div>
            <div class="h_bg p50">
              <h3>转账信息</h3>
              <span>请选择支付方式后，完成支付。若通过”代收代付“方式已支付，可选择”自行转账“方式，上传支付凭证。</span>
            </div>
            <div class="demo-input-suffix p50" v-if="data.tranferType == 1">
              <span v-if="isPromisePayed == 0" style="margin-right: 20px">交易保证金(元)</span>
              <span v-if="isPromisePayed == 0" class="redF">{{data.tranferEnsureAmount}}</span>
            </div>
            <div class="demo-input-suffix p50" v-else>
              <span style="margin-right: 20px">{{
                formData.payType == 1
                  ? '投资金额'
                  : formData.payType == 2
                  ? '预付款'
                  : '支付金额'
              }}</span>
              <span class="redF">{{
                  formData.payType == 1
                    ? data.amount
                    : formData.payType == 2
                    ? data.advancePaymentAmount
                    : '0.00'
                }}元</span>
            </div>
            <div class="demo-input-suffix p50" v-if="data.payWay==2&&data.tranferType != 1&&formData.payType==1">
              <span style="margin-right: 20px">首期支付金额</span>
              <span class="redF">{{formData.firstStageAmount}}元</span>
            </div>
            <div class="radio-group-wrap p50">
              <el-radio-group v-model="formData.payMethod" :disabled="formData.payType == 3 || formData.payType == 4">
                <el-radio label="2">自行转账</el-radio>
<!--                <el-radio label="1">代收代付</el-radio>-->
                <el-radio label="3">代收代付</el-radio>
              </el-radio-group>
            </div>
            <div class="content-group p50">
              <div class="group-tyep" v-if="formData.payMethod == 2" :class="{ active: formData.payMethod == 2 }">
                <el-form-item label="开户银行">{{ openBank }}</el-form-item>
                <el-form-item label="账户名">{{ accountName }}</el-form-item>
                <el-form-item label="账号">{{ bankAccount }}</el-form-item>
                <div style="margin: 10px 0">
                  <div v-for="(item, index) in formData.payEvidences" :key="index">
                    <span v-if="item.url" class="imgWrapss">
                      <el-image :src="item.url" style="width: 200px; height: 150px"></el-image>
                      <i @click.prevent.stop="formData.payEvidences.splice(index, 1)" class="el-icon-delete"></i>
                    </span>
                  </div>
                  <Upload v-model="fileUrl" buttonText="上传缴费凭证（选填)" @fileNameEvt="payFileNameEvt" :size="true"></Upload>
                </div>
                <div v-if="data.tranferType == 1 ">
                  <p>请补充以下银行信息，以便于保证金退还使用</p>
                  <el-form-item label="银行账户">
                    <div class="flex_auto">
                      <el-select v-model="formData.bankAccount" @change="changeSelectBank()">
                        <el-option v-for="item in bankList" :key="item.bankCard" :label="item.openBank" :value="item.bankCard"></el-option>
                      </el-select>
                      <el-button @click="$router.push({name:'managementPersonal'})" style="margin-left: 15px;"> 添加银行卡</el-button>
                    </div>
                  </el-form-item>
                  <el-form-item label="开户银行">
                    <el-input v-model="formData.openBank" placeholder="请输入开户银行" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="银行行号">
                    <el-input v-model="formData.bankCode" placeholder="请输入银行行号"></el-input>
                  </el-form-item>
                </div>
                <!-- <AgreeDialog @checkAgree="checkAgreeEvt" @agreementName="getAgreeName"></AgreeDialog> -->
              </div>
              <div class="group-tyep" v-if="formData.payMethod == 1" :class="{'active': formData.payMethod == 1}">
                <div>
                  <el-form-item label="银行账户">
                    <div class="flex_auto">
                      <el-select v-model="formData.payBankAccount" @change="changeSelectBank('pay')">
                        <el-option v-for="item in bankList" :key="item.bankCard" :label="`${item.bankName}(${item.bankCard.slice(-4)})`" :value="item.bankCard"></el-option>
                      </el-select>
                      <el-button @click="$router.push({name:'managementPersonal'})" style="margin-left: 10px;"> 添加银行卡</el-button>
                    </div>
                  </el-form-item>
<!--                  <div>-->
<!--                    <el-checkbox v-model="checked"></el-checkbox>-->
<!--                    我已阅读，并同意-->
<!--                    <el-link v-if="formData.userType == 2" style="color: rgb(4, 126, 255)" :underline="false" href="https://fdfs.zct.gjsc.info/group1/M00/00/6C/wKgECl-acBCADIq1AAHEh07Ao8Q471.pdf" target="_blank">《企业付款授权协议》</el-link>-->
<!--                    <el-link v-if="formData.userType == 1" style="color: rgb(4, 126, 255)" :underline="false" href="https://fdfs.zct.gjsc.info/group1/M00/00/6C/wKgECl-acJqAYQIhAAHFkrIi8UA284.pdf" target="_blank">《个人付款授权协议》</el-link>-->
<!--                  </div>-->
                </div>
              </div>
              <div class="group-tyep" v-if="formData.payMethod == 3" :class="{'active': formData.payMethod == 3,'right-active': formData.payMethod == 3 }">
                <el-form ref="formData" label-position="left" label-width="140px" size="mini">
                  <el-form-item label="支持以下支付方式：">
                    <div class="pay">银行卡支付</div>
                    <div class="pay bef">微信支付</div>
                    <div class="pay befs">支付宝支付</div>
                  </el-form-item>
<!--                  <div>-->
<!--                    <el-checkbox v-model="checked"></el-checkbox>-->
<!--                    我已阅读，并同意-->
<!--                    <el-link v-if="formData.userType == 2" style="color: rgb(4, 126, 255)" :underline="false" href="https://fdfs.zct.gjsc.info/group1/M00/00/6C/wKgECl-acBCADIq1AAHEh07Ao8Q471.pdf" target="_blank">《企业付款授权协议》</el-link>-->
<!--                    <el-link v-if="formData.userType == 1" style="color: rgb(4, 126, 255)" :underline="false" href="https://fdfs.zct.gjsc.info/group1/M00/00/6C/wKgECl-acJqAYQIhAAHFkrIi8UA284.pdf" target="_blank">《个人付款授权协议》</el-link>-->
<!--                  </div>-->
                  <div style="margin: 20px 0 0">
                    <el-button @click="payEvt()" :disabled="formData.payMethod != 3 || (formData.payType == 1
                    ? data.amount
                    : formData.payType == 2
                    ? data.advancePaymentAmount
                    : '0.00') == 0">点击付款</el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="dia_wrap" v-else>
        <el-form class="form" ref="OfflineRef" :model="OfflineData" :rules="OfflineRefRules" label-position="right" label-width="140px" size="mini">
          <div>
            <div class="h_bg p50" style="margin-top: 0">
              <h3>填写联系方式</h3>
              <span>带“*”号为必填项</span>
            </div>
            <div class="m50">
              <el-form-item label="名称：" prop="name">
                <el-input disabled class="input_width" v-model="OfflineData.name"  placeholder="请输入姓名" :maxlength="10"></el-input>
              </el-form-item>
              <el-form-item label="手机号码：" prop="contactNumber">
                <el-input disabled class="input_width" v-model.trim="OfflineData.contactNumber"  placeholder="请输入手机号码" :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="报价金额(元)：" prop="quotedAmount">
                <el-input class="input_width" v-model.trim="OfflineData.quotedAmount"  placeholder="请输入报价金额" :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="联系地址：" prop="contactAddress">
                <el-input class="input_width" v-model="OfflineData.contactAddress"  placeholder="请输入联系地址" :maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="相关资料：">
                <Upload v-model="fileOfflineUrlInfo" @fileNameEvt="fileNameOfflineEvt" buttonText="上传资料" :size="true"></Upload>
                <div v-for="(item, index) in OfflineData.delistingOfflineFile" :key="index">
                  <div class="lookAddr">
                    <span class="name">{{ item.name }}</span>
                    <el-link class="mr20 blueC" :underline="false" v-if="item.url" :href="item.url" target="_blank">详情</el-link>
                    <i @click.prevent.stop="OfflineData.delistingOfflineFile.splice(index, 1)" class="el-icon-delete"></i>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="btn">
        <el-button @click="close">取 消</el-button>
        <el-button class="sumbit" @click="saveAndSubmitBtn()">确认提交</el-button>
      </div>
    </el-dialog>
    <!-- //上传营业执照 -->
    <el-dialog width="400px" top="30vh" title="上传营业执照" :visible.sync="upDia" append-to-body :close-on-click-modal="false">
      <el-row>
        <div v-if="upContentShow">
          <Upload v-model="imgUrl" buttonText="上传" :size="false"></Upload>
          <div class="upload_warp_one" v-if="imgUrl">
            <img class="upload_close" src="@/assets/close.png" alt="" @click="imgUrl = ''" />
            <el-image :src="imgUrl" style="width: 190px"></el-image>
          </div>
        </div>
        <div v-else class="dialog_wrap">
          已提交后台审核，审核结果会在通知中心进行通知。
        </div>
        <div class="btnDia">
          <el-button @click="upDia = false" v-if="upContentShow">取消</el-button>
          <el-button class="btn-2" @click="submitImg()" v-if="upContentShow">提交</el-button>
          <el-button class="btn-2" @click="upDia = false" v-else>确定</el-button>
        </div>
      </el-row>
    </el-dialog>
    <Dialog :show="diaShow" @dialogClose="diaShow = false" :title="'温馨提示'" :content="contentMsg" :btn2="'知道了'" />
    <payQrcode :qrUrl.sync="qrUrlData" :id.sync="data.id" @JSpayStatus="confirmpayStatus()" />
    <!-- 捷算支付人脸 -->
    <faceQrcode v-if="qrShow" ref="qr" @notify="notify"></faceQrcode>
    <!-- 转账提示 -->
    <paySure :pay.sync="payInfoSure"  @operateSureEvt="operateSureEvt"> </paySure>
  </div>
</template>
<script>
import Upload from '@/components/Upload/UpLoad.vue'
import publicFunction from '@/utils/publicFunction'
import Dialog from '@/components/Dialog'
import payQrcode from '@/components/payQrcode'
import faceQrcode from '@/components/faceQrcodes/index.vue'
import OneUpload from '@/components/DataUpload/OneUpload.vue'
import ListUpload from '@/components/DataUpload/ListUpload.vue'
import paySure from '@/components/paySure/index.vue'
import { floatSub, floatDiv } from '@/utils/basicOperation'
import {sessionStore} from "@/utils/data-management";
// import AgreeDialog from '@/components/agreeDialog'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: '',
    },
  },
  components: {
    Upload,
    Dialog,
    OneUpload,
    ListUpload,
    payQrcode,
    faceQrcode,
    paySure,
    // AgreeDialog,
  },
  data() {
    return {
      stageNumOptions: [
        {
          name: '二期',
          value: 2
        },
        {
          name: '三期',
          value: 3
        },
        {
          name: '四期',
          value: 4
        },
        {
          name: '五期',
          value: 5
        },
        {
          name: '六期',
          value: 6
        },
        {
          name: '七期',
          value: 7
        },
        {
          name: '八期',
          value: 8
        },
        {
          name: '九期',
          value: 9
        },
        {
          name: '十期',
          value: 10
        },
        {
          name: '十一期',
          value: 11
        },
        {
          name: '十二期',
          value: 12
        }
      ],
      qrShow: false, //代收代付人脸识别
      qrUrlData: '', //支付二维码
      payStatus: false, //是否已支付
      upDia: false, //上传营业执照弹框
      upContentShow: true,
      diaShow: false,
      msgDia: false,
      loading: false,
      contentMsg: '',
      rules: {
        stageNum: [{ required: true, message: '请选择分期数', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        identityCode: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
        ],
        legalPerson: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' },
        ],
        enterpriseName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
        ],
        registAddress: [
          { required: true, message: '请输入住址', trigger: 'blur' },
        ],
        creditCode: [
          { required: true, message: '请输入统一信用代码', trigger: 'blur' },
        ],
        bankAccount: [
          { required: true, message: '请输入公司银行账户', trigger: 'blur' },
        ],
        openBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
        ],
        payBankAccount: [
          { required: true, message: '请输入公司银行账户', trigger: 'blur' },
        ],
        // bankCode: [
        //   { required: true, message: '请输入银行行号', trigger: 'blur' }
        // ],
      },
      OfflineRefRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        contactNumber: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        quotedAmount: [{ required: true, message: '请输入报价金额', trigger: 'blur' }]
      },
      formData: {
        stageAmount: '', // 分期金额
        stageNum: '', // 分期期数
        firstStageAmount: '', // 首期金额
        eachStageAmount: '', // 剩余每期平均金额
        listingApplyId: '',
        payMethod: '2', // 1 代收代付  2 自行转账
        delistingInfos: [], // 上传的资料
        userType: '1', //  用户类型 1 个人 2 企业
        name: '', // 姓名 （个人必填）
        identityCode: '', // 身份证号 （个人必填）
        contactPhone: '', // 联系电话 （个人/企业必填）
        contactAddress: '', // 联系地址 （个人必填）
        legalPerson: '', // 法定代表人 （企业必填）
        enterpriseName: '', //企业名称 （企业必填）
        registAddress: '', //注册地址 （企业必填）
        payType: 1, //1 全额付款 2 预付款 3 交付后付款 4 其他
        bankAccount: '', //银行账户 （必填）
        openBank: '', //开户银行
        bankCode: '', //银行行号
        amount: '', //
        payInfo: '',
        payEvidences: [], //支付凭证
        creditCode: '', //统一信用代码
        fileList: [],
        cloudPayId: '',
        payBankAccount: '',
        payBankName: '',
        areaId: '',
        feeType: '',
        callbackId: '',
      },
      OfflineData: {
        name: '',
        contactNumber: '',
        contactAddress: '',
        quotedAmount: '',
        delistingOfflineFile: [],
        callbackId: '',
        userType: '1',
      },
      investmentAmount: '', //投资金额
      openBank: '',
      accountName: '',
      bankAccount: '',
      fileUrl: '',
      fileUrlInfo: '',
      fileOfflineUrlInfo: '',
      bankCardId: '',
      checked: true,
      fileName: '',
      fileNameS: '',
      fileNameOffline: '',
      //根据输入的银行账匹配相关信息
      getBankCardInfo: {
        openBank: '', //开户行号
        bankName: '', //开户银行名称
      },
      bankDisable: false,
      isPromisePayed: 0,
      fileList: [],
      applyStatus: -1, // 是否展示其他支付方式
      imgUrl: '',
      bankList: [], //代收代付银行卡列表
      payInfoSure:{
        accountName: '',
        bankAccount: '',
        amount: '',
        tranferEnsureAmount: ''
      },
      agreementName:'',
      checkAgree: false,
    }
  },
  watch: {
    fileUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.payEvidences.push({
            url: newVal,
            name: this.fileNameS,
          })
          this.fileUrl = ''
          this.fileNameS = ''
        }
      },
    },
    fileUrlInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.delistingInfos.push({
            url: newVal,
            name: this.fileName,
          })
          this.fileUrlInfo = ''
          this.fileName = ''
        }
      },
    },
    fileOfflineUrlInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.OfflineData.delistingOfflineFile.push({
            url: newVal,
            name: this.fileNameOffline,
          })
          this.fileOfflineUrlInfo = ''
          this.fileNameOffline = ''
        }
      },
    },
    show: {
      async handler(newVal, oldVal) {
        if (newVal == true) {
          // if (this.formData.userType == 1) {
          //   this.formData.name = this.$store.state.userInfo.name
          //   this.formData.identityCode = this.$store.state.userInfo.idCard
          // }
          this.getCompanyInfo() //获取自行转账的相关银行信息
          if (this.data.tranferType == 1) {
            //查询是否二次报价 data.tranferType == 1 ? '申请报价': '申请摘牌'
            this.delistingGetDetail()
          } else if (this.data.tranferType == 4) {
            this.delistingGetOfflineDetail()
          } else {
            //摘牌上传文件
            this.getapplyFile()
            this.getAuthInfo()
            this.getBankList() //获取代收代付银行卡列表
          }
        }
      },
    },
    upDia: {
      handler(newVal, oldVal) {
        if (newVal == true) {
          this.upContentShow = true
        }
      },
    },
  },
  methods: {
    stageNumOptionsFilter() {
      let returnOptions = [...this.stageNumOptions]
      if (this.data.amount<=0.01) {
        returnOptions.unshift({
          name: '一期',
          value: 1
        },)
      }
      return returnOptions
    },
    getTwoBit(num) {
      return Math.floor(num * 100)/100
    },
    getMultiple(firstNum, secondNum, returnMultiple) {
      if (firstNum < secondNum) {
        returnMultiple = returnMultiple*10
        if (firstNum*returnMultiple<secondNum) {
          returnMultiple = this.getMultiple(firstNum, secondNum, returnMultiple)
        }
      }
      return returnMultiple
    },
    stageNumFn(v) {
      let eachStageAmount = 0,
      firstStageAmount = 0
      if (this.data.amount&&this.data.amount!=0) {
        if (v!=1) {
          let multiple = this.getMultiple(this.data.amount, v, 1),
          remainder = (this.data.amount*multiple)%v
          if (remainder>0) {
            eachStageAmount = floatDiv(floatSub(this.data.amount*multiple, remainder), v)
            firstStageAmount = eachStageAmount + remainder
          } else {
            eachStageAmount = floatDiv(this.data.amount*multiple, v)
            firstStageAmount = eachStageAmount
          }
          this.formData.eachStageAmount = this.getTwoBit(eachStageAmount/multiple)
          this.formData.firstStageAmount = this.getTwoBit(firstStageAmount/multiple)
        } else {
          let nowVal = this.data.amount<=0.01?this.data.amount:this.getTwoBit(this.data.amount)
          this.formData.eachStageAmount = nowVal
          this.formData.firstStageAmount = nowVal
        }
      } else {
        this.formData.eachStageAmount = eachStageAmount
        this.formData.firstStageAmount = firstStageAmount
      }
    },
    getAgreeName(v){
      this.agreementName = v
    },
    checkAgreeEvt(v){
      this.checkAgree = v
    },
    confirmpayStatus(v) {
      this.payStatus = true
    },
    async payEvt() {
      let amount = 0
      if(this.data.tranferType == 1){
        amount = Number(this.data.tranferEnsureAmount)* 100
      }else {
        amount = Number(
            this.formData.payType == 1
                ? this.data.amount
                : this.formData.payType == 2
                ? this.data.advancePaymentAmount
                : 0
        ) * 100
      }
      const params = {
        amount,
        remarks: '',
        linkId: this.data.id,
        payType: 0,
        areaConfigId: this.data.areaConfigId,
      }
      this.loading = true
      await this.$api.apply
        .perPay(params)
        .then((res) => {
          if (res.code === 1000) {
            this.qrUrlData = res.data
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false
        })
    },
    async submitImg() {
      if (!this.formData.enterpriseName)
        return this.$message.error('请输入企业名称')
      if (!this.imgUrl) return this.$message.error('请上传营业执照')
      const params = {
        areaConfigId: this.data.areaConfigId,
        businessLicense: this.imgUrl,
        companyName: this.formData.enterpriseName,
        unifiedCreditCode: this.formData.creditCode,
        type: 0,
      }
      this.loading = true
      await this.$api.apply.approvalAdd(params)
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success('提交成功')
            this.imgUrl = ''
            this.upContentShow = false
            this.getAuthInfo()
          } else {
            this.loading = false
          }
        })
        .catch((error) => {
          this.loading = false
        })
        .finally(() => {})
    },
    changeSelectBank(flag) {
      if (this.bankList && this.bankList.length > 0) {
        if (flag == 'pay') {
          this.bankList.forEach((item) => {
            if (this.formData.payBankAccount == item.bankCard) {
              this.formData.payBankName = item.bankName
            }
          })
        } else {
          if (this.formData.bankAccount) {
            this.bankList.forEach((item) => {
              if (this.formData.bankAccount == item.bankCard) {
                this.formData.openBank = item.bankName
              }
            })
          }
        }
      }
    },
    //根据输入的银行账匹配相关信息
    // bankAccountChange() {
    // if (this.formData.bankAccount) {
    // this.loading = true;
    // this.$api.my
    //   .getBankCardByCardNo({ bankCard: this.formData.bankAccount })
    //   .then((res) => {
    //     if (res.code === 1000) {
    //       this.getBankCardInfo = res.data;
    //       this.formData.bankCode = res.data.openBank;
    //       this.formData.openBank = res.data.bankName;
    //       this.bankDisable = true;
    //     } else {
    //       this.bankDisable = false;
    //       this.getBankCardInfo = {
    //         openBank: '', //开户行号
    //         bankName: '', //开户银行名称
    //       };
    //       this.formData.bankCode = '';
    //       this.formData.openBank = '';
    //     }
    //   })
    //   .catch((error) => {
    //     this.bankDisable = false;
    //     this.getBankCardInfo = {
    //       openBank: '', //开户行号
    //       bankName: '', //开户银行名称
    //     };
    //     this.formData.bankCode = '';
    //     this.formData.openBank = '';
    //   })
    //   .finally(() => {
    //     this.loading = false;
    //   });
    // }
    // },
    fileNameEvt(v) {
      this.fileName = v
    },
    payFileNameEvt(v) {
      this.fileNameS = v
    },
    fileNameOfflineEvt(v) {
      this.fileNameOffline = v
    },
    // 重置信息
    changeRadio() {
      this.bankDisable = false
      // this.formData.name = this.$store.state.userInfo.name
      // this.formData.identityCode = this.$store.state.userInfo.idCard
      this.formData.contactPhone = ''
      this.formData.contactAddress = ''
      this.formData.creditCode = ''
      this.formData.legalPerson = ''
      this.formData.enterpriseName = ''
      this.formData.registAddress = ''
      this.formData.bankAccount = ''
      this.formData.openBank = ''
      this.formData.bankCode = ''
      this.getBankList()
    },
    close() {
      this.$emit('dialogCloses', false)
    },
    saveAndSubmitBtn() {
      if (this.data.tranferType != 4) {
        this.$refs.formRef.validate((v) => {
          if (v) {
            if (this.data.payWay==2&&this.data.tranferType != 1&&this.formData.payType==1&&!this.formData.firstStageAmount) {
              return this.$message.error('首期金额不能为0')
            }
            if (this.formData.userType == 1) {
              if (!publicFunction.isIdCard(this.formData.identityCode)) {
                return this.$message.error('身份证填写错误')
              }
            }
            if (
              !publicFunction.isPhone(this.formData.contactPhone) ||
              !publicFunction.isTel(this.formData.contactPhone)
            ) {
              return this.$message.error('联系号码填写错误')
            }
            if (
              this.formData.payMethod == 1 &&
              (!this.formData.payBankAccount || !this.formData.payBankName)
            )
              return this.$message.error('请选择代收代付的银行账户')
            if (this.formData.payType == 4 && !this.formData.payInfo)
              return this.$message.error('请输入其他摘牌方式')
            if (this.formData.payMethod == 1 && !this.checked)
              return this.$message.error('请阅读并勾选付款协议')
            // (!this.formData.payBankAccount || !this.formData.payBankName)
            if (
              this.formData.payMethod == 1 &&
              (!this.formData.payBankAccount || !this.formData.payBankName)
            )
              return this.$message.error('请选择代收代付银行卡')
            if (
              this.formData.payMethod == 3 &&
              !this.payStatus &&
              (this.formData.payType == 1
                ? this.data.amount
                : this.formData.payType == 2
                  ? this.data.advancePaymentAmount
                  : '0.00') > 0
            )
              return this.$message.error('请点击付款按钮进行扫码支付')
            if (this.data.tranferType == 1) {
              if (!this.formData.amount) {
                return this.$message.error('请输入报价金额')
              } else {
                let minAmout = Number(this.data.maxReportAmount)
                  ? Number(this.data.maxReportAmount) +
                  Number(this.data.auctionInterval)
                  // : Number(this.data.amount) + Number(this.data.auctionInterval)
                  : Number(this.data.amount)
                // minAmout = Math.round(minAmout*100)/100
                if (this.formData.amount < minAmout) {
                  let a = Math.round((Number(this.data.maxReportAmount) + Number(this.data.auctionInterval))*100)/100
                  // let b = Math.round((Number(this.data.amount) + Number(this.data.auctionInterval))*100)/100
                  let b = Math.round(Number(this.data.amount)*100)/100
                  this.contentMsg = `<p>报价金额不能低于:${this.data.maxReportAmount ? a + '元' : b + '元'
                  }${
                    // this.data.maxReportAmount ? '(最高报价+竞价阶梯)' : '(起拍金额+竞价阶梯)'
                    this.data.maxReportAmount ? '(最高报价+竞价阶梯)' : '(起拍金额)'
                  }</p>
                  <p>${
                    this.data.maxReportAmount ? '最高报价为:' + this.data.maxReportAmount + '元' : '起拍金额为:' + this.data.amount + '元'
                  }</p>
                  <p> ${'竞价阶梯为:' + this.data.auctionInterval + '元'}</p>`
                  this.diaShow = true
                  return false
                }
              }
            } else {
              const check = this.checkFileAddr(this.fileList)
              let directionalFinancingFiles = []
              if (check) {
                this.fileList.forEach((item) => {
                  const obj = {
                    downloadUrl: item.downloadUrl,
                    fileName: item.fileName,
                    fileType: item.fileType,
                    fileUrl: [],
                    flag: item.flag,
                    id: item.id,
                    isLast: item.isLast,
                    isRequire: item.isRequire,
                    listingApplyId: item.listingApplyId,
                    maxNumber: item.maxNumber,
                  }
                  if (item.maxNumber == 1 && item.fileList[0]) {
                    obj.fileUrl.push(item.fileList[0].fileUrl || '')
                  } else {
                    item.fileList.forEach((i) => {
                      obj.fileUrl.push(i.fileUrl || '')
                    })
                  }
                  directionalFinancingFiles.push(obj)
                })
                this.formData.fileList = directionalFinancingFiles
              } else {
                return false
              }
            }
            // if ( this.formData.payMethod == 2 && this.agreementName && !this.checkAgree)
            // return this.$message.error(`请阅读并勾选《${this.agreementName}》`);
            if(this.formData.payMethod == 2 && (!this.accountName || !this.bankAccount)
            ) {
              return this.$message.error('当前区域未配置收款银行卡,暂不支持自行转账,请联系管理员')
            } else {
              this.payInfoSure = {
                tranferEnsureAmount: this.data.tranferType == 1 ? this.data.tranferEnsureAmount : '',
                accountName: this.formData.payMethod == 2 ? this.accountName :this.formData.payBankName,
                bankAccount: this.formData.payMethod == 2 ? this.bankAccount :this.formData.payBankAccount,
                amount: this.data.tranferType == 1 ? this.formData.amount : ( this.formData.payType == 1 ? (this.data.payWay==2?this.formData.firstStageAmount:this.data.amount) : this.formData.payType == 2 ? this.data.advancePaymentAmount : '0.00'),
              }
            }
            if(this.formData.payMethod==3){
              this.operateEvt()
            }
          }else {
            this.$message.error('请完善信息')
          }
        })
      } else {
        this.$refs.OfflineRef.validate((v) => {
          if (v) {
            this.operateOfflineEvt()
          }
        })
      }
    },
    dialogSumbitR() {
      this.diaShow = false
    },
    //查询当前企业是否可用其他方式摘牌
    async getAuthInfo() {
      if (this.formData.creditCode) {
        if (this.data.tranferType == 1) return ///申请报价return
        this.loading = true
        await this.$api.apply
          .getAuthInfo({
            areaConfigId: this.data.areaConfigId,
            unifiedCreditCode: this.formData.creditCode,
            type: 0,
          })
          .then((res) => {
            if (res.data.status != null) {
              this.applyStatus = res.data.status * 1
            } else {
              this.applyStatus = 2
            }
          })
          .catch((error) => {})
          .finally(() => {
            this.loading = false
          })
      }
    },
    async getapplyFile() {
      this.loading = true
      await this.$api.my
        .applyFile({ applyId: this.data.id })
        .then((res) => {
          this.fileList = res.data
          this.fileList.forEach((item) => {
            this.$set(item, 'fileList', [])
            this.$set(item, 'canDownload', item.downloadUrl ? true : false)
            this.$set(item, 'status', false)
            if (item.fileUrl) {
              if (item.maxNumber == 1) {
                item.fileList.push({
                  fileName: item.fileName,
                  fileUrl: item.fileUrl ? item.fileUrl[0] : '',
                  fileType: item.fileType,
                })
              } else {
                item.fileUrl.forEach((i) => {
                  item.fileList.push({
                    fileName: item.fileName,
                    fileUrl: i ? i : '',
                    fileType: item.fileType,
                  })
                })
              }
            }
          })
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false
        })
    },
    checkFileAddr(list) {
      return (
        list &&
        list.every((item) => {
          if (
            item.isRequire &&
            (!item.fileList ||
              !item.fileList.length ||
              !item.fileList[0].fileUrl)
          ) {
            this.$message.error(`请将《${item.fileName}》的相关资料上传完善`)
            return false
          } else {
            return true
          }
        })
      )
    },
    async delistingGetOfflineDetail() {
      this.loading = true
      await this.$api.my.delistingGetOfflineDetail({ listingApplyId: this.data.id }).then((res) => {
        if (res.code === 1000) {
          console.log("data",res.data)
          this.OfflineData.quotedAmount = res.data.quotedAmount
          this.OfflineData.contactAddress = res.data.contactAddress
          if (res.data.delistingOfflineFile != null) {
            this.OfflineData.delistingOfflineFile = res.data.delistingOfflineFile
          }
        }
      }).catch((error) => {}).finally(() => {
      this.loading = false
    })
    },
    async delistingGetDetail() {
      this.loading = true
      await this.$api.my.delistingGetDetail({ listingApplyId: this.data.id }).then((res) => {
        if (res.code === 1000) {
          this.isPromisePayed = res.data.isPromisePayed
          if (res.data.isPromisePayed == 1) {
            this.formData.userType = res.data.userType + ''
            this.formData.contactPhone = res.data.contactPhone
            this.formData.contactAddress  = res.data.contactAddress
            this.formData.legalPerson = res.data.legalPerson
            this.formData.enterpriseName = res.data.enterpriseName
            this.formData.registAddress = res.data.registAddress
            this.formData.creditCode = res.data.creditCode
            this.formData.bankAccount = res.data.bankAccount
            this.formData.openBank = res.data.openBank
            this.formData.bankCode = res.data.bankCode
          }
          this.getBankList() //获取代收代付银行卡列表
        }
      }).catch((error) => {}).finally(() => {
        this.loading = false
      })
    },
    operateSureEvt() {
      if (this.formData.payMethod == 1) {
        this.qrShow = true
      } else {
        this.operateEvt()
      }
    },
    notify(v) {
      this.qrShow = false
      if (v) {
        this.formData.callbackId = this.$refs.qr.callbackId
        setTimeout(() => {
          this.operateEvt()
        }, 500)
      }
    },
    async operateOfflineEvt() {
      this.OfflineData.listingApplyId = this.data.id
      this.loading = true
      await this.$api.my.operateOffline(this.OfflineData).then((res) => {
        if (res.code === 1000) {
          this.$emit('diaSccessEvt', true)
          this.loading = false
        } else {
          this.loading = false
        }
      }).catch((error) => {
        this.loading = false
      }).finally(() => {})
    },
    async operateEvt() {
      this.msgDia = false
      this.data.payWay==2&&this.data.tranferType != 1&&this.formData.payType==1&&(this.formData.stageAmount = this.data.amount)
      this.formData.listingApplyId = this.data.id
      this.formData.cloudPayId = this.qrUrlData.id
      this.formData.areaId = this.data.areaConfigId
      this.formData.feeType = this.data.tranferType == 1 ? '0' : '1'
      this.loading = true
      await this.$api.my.operate(this.formData).then((res) => {
        if (res.code === 1000) {
          this.$emit('diaSccessEvt', true)
          this.loading = false
        } else {
          this.loading = false
        }
      }).catch((error) => {
        this.loading = false
      }).finally(() => {})
    },
    //获取自行转账的相关银行信息
    async getCompanyInfo() {
      await this.$api.my.getFeeItem({
        areaId: this.data.areaConfigId,
        feeType: this.data.tranferType == 1 ? '0' : '1',
      }).then((res) => {
        if (res.code === 1000) {
          if (res.data) {
            this.openBank = res.data.bankName
            this.accountName = res.data.accountName
            this.bankAccount = res.data.bankCard
          }
        }
      })
    },
    //获取代收代付银行卡
    async getBankList() {
      this.bankList = []
      let type =  this.formData.userType == '2' ? 4 : this.formData.userType == '3' ? 4 : this.formData.userType
      console.log(type);
      await this.$api.user.getMyCard({
        type
      }).then((res) => {
        if (res.code == 1000 && res.data && res.data.length) {
          this.bankList = res.data
          if (res.data && res.data.length) {
            this.bankList.forEach((item) => {
              if (item.isDefault == 1) {
                this.formData.bankAccount = this.formData.payBankAccount =
                  item.bankCard //银行账户 （必填）
                this.formData.openBank = this.formData.payBankName =
                  item.bankName //开户银行
              }
            })
          }
        }
      })
    },
  },
  computed: {
    isShowBtn(){
      const userInfo = this.$store.state.userInfo
      return userInfo.userType===2&&userInfo.companyNature===1
    }
  },
  created() {
    if(sessionStore.get('userInfo')){
      const userInfo = sessionStore.get('userInfo')
      this.$set(this.formData,'userType',userInfo.userType.toString())
      this.$set(this.OfflineData,'userType',userInfo.userType.toString())
      if(userInfo.userType===2 || userInfo.userType===3){
        this.$set(this.formData,'enterpriseName',userInfo.companyName)
        this.$set(this.formData,'creditCode',userInfo.unifiedCreditCode)
        this.$set(this.formData,'registAddress',userInfo.registAddress)
        this.$set(this.formData,'legalPerson',userInfo.name)
        this.$set(this.OfflineData,'name',userInfo.companyName)
        this.$set(this.OfflineData,'contactNumber',userInfo.phone)
      }
      if(userInfo.userType===1){
        this.$set(this.formData,'name',userInfo.name)
        this.$set(this.formData,'identityCode',userInfo.idCard)
        this.$set(this.OfflineData,'name',userInfo.name)
        this.$set(this.OfflineData,'contactNumber',userInfo.phone)
      }
    }
  }
}
</script>
<style lang="scss">
.radio-group-wrap .el-radio-group .el-radio{
  width: 100px !important;
}
.content-group{
  .active.right-active::after {
   left: 200px;
  }
}
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
.form {
  /deep/.actives {
    .el-form-item__label::before {
      content: '*';
      display: inline-block;
      vertical-align: middle;
      color: #f56c6c;
      margin-right: 4px;
      font-size: 20px;
    }
  }
}
</style>
